
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'

var BuyApplyPage = Vue.extend({})
Vue.component('buyApply-page', BuyApplyPage)

export default {
  name: 'BuyApplyPage',
  components: {
    XTable
  },
  props: {

  },
  data () {
    return {
      baseUrl: this.$store.state.url,
      flowId: ''
    }
  },
  mounted () {
    // this.$emit('sendTitleToParent','借款申请');
  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/components/launch/attendance/buyApply.vue